export interface PresignedUrl {
  presignedUrl: string;
  resourceAddress: string;
}
